'use client';

import React, { useState } from 'react';

import { useAuthContext } from '@/components/Providers/AuthProvider';
import { useAppSelector } from '@/store';
// import { useGetVolumnsDetailsQuery } from '@/store/api/dashboard';
import { VolumnsDetailsResponse } from '@/types/Dashboard';
import { SuccessResponse } from '@/types/Success';

import ReportsLoader from '../Reports/CustomerDetailModal/ReportsLoader';
import VolumeBucketModels from '../Reports/VolumeBucketModals/VolumeBucketModels';
import VolumnCard from './Components/VolumnCard';

const VolumnsCardsContainer = () => {
  const { customer } = useAuthContext();
  const customerId = customer?.customerID ?? 0;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [volumeBucketLabel, setVolumeBucketLabel] = useState('');
  const [isTableView, setIsTableView] = useState(false);
  const [volumeBucket, setVolumeBucket] = useState<number>();
  const retailPowerBonusData = useAppSelector(state => state.slices.dashboard.dashboardData?.volumesData) || {};

  // const { data: apiResp, isLoading, isFetching } = useGetVolumnsDetailsQuery(undefined, { skip: skipVolumesDetails });
  const isLoading = false;
  const isFetching = false;
  const data: SuccessResponse<VolumnsDetailsResponse> = {
    data: retailPowerBonusData,
    success: true,
    message: '',
    exceptionMessage: '',
  };

  return (
    <div className="v2-shadow-md v2-p-8 md:v2-p-8 sm:v2-p-4 xs:v2-p-4 v2-bg-white v2-rounded-xs">
      <div className="v2-pb-[12px] v2-border-b v2-border-[#E5E5E5] v2-mb-[20px]">
        <h2 className="v2-text-[#05004E] v2-font-sweet-sans-pro-bold v2-font-bold v2-text-xl">Volumes</h2>
      </div>
      {isLoading || isFetching ? (
        <div className="v2-h-[214px] v2-flex v2-justify-center v2-items-center">
          <ReportsLoader />
        </div>
      ) : (
        <div className="v2-grid v2-grid-cols-6 xl:v2-grid-cols-6 lg:v2-grid-cols-3 md:v2-grid-cols-3 sm:v2-grid-cols-2 xs:v2-grid-cols-1 v2-gap-4 md:v2-gap-5">
          <VolumnCard
            label="Sponsoring"
            count={data?.data.sponsoring ?? 0}
            onClick={() => {
              if (!data?.data.sponsoring) return;
              setIsModalOpen(true);
              setVolumeBucketLabel('Sponsoring');
              setIsTableView(false);
              setVolumeBucket(23);
            }}
            className="!v2-bg-[#EFC6B6]"
            iconColor="#EFC6B6"
          />
          <VolumnCard
            label="NPV"
            count={data?.data.npv ?? 0}
            onClick={() => {
              if (!data?.data.npv) return;
              setIsModalOpen(true);
              setVolumeBucketLabel('MTD New PV');
              setIsTableView(false);
              setVolumeBucket(14);
            }}
            className="!v2-bg-[#E08D6E]"
            iconColor="#E08D6E"
          />
          <VolumnCard
            label="PV"
            count={data?.data.pv ?? 0}
            onClick={() => {
              if (!data?.data.pv) return;
              setIsModalOpen(true);
              setVolumeBucketLabel('MTD Total PV');
              setIsTableView(false);
              setVolumeBucket(1);
            }}
            className="!v2-bg-[#8390A4]"
            iconColor="#8390A4"
          />
          <VolumnCard
            label="EZ PV"
            count={data?.data.ezpv ?? 0}
            onClick={() => {
              if (!data?.data.ezpv) return;
              setIsModalOpen(true);
              setVolumeBucketLabel('Processed MTD');
              setIsTableView(false);
              setVolumeBucket(25);
            }}
            className="!v2-bg-[#082149]"
            iconColor="#082149"
          />
          <VolumnCard
            label="DV"
            count={data?.data.dv ?? 0}
            onClick={() => {
              if (!data?.data.dv) return;
              setIsModalOpen(true);
              setVolumeBucketLabel('Total MTD DV');
              setIsTableView(false);
              setVolumeBucket(3);
            }}
            className="!v2-bg-[#91A29A]"
            iconColor="#91A29A"
          />
          <VolumnCard
            label="GV"
            count={data?.data.gv ?? 0}
            onClick={() => {
              if (!data?.data.gv) return;
              setIsModalOpen(true);
              setVolumeBucketLabel('Total MTD GV');
              setIsTableView(false);
              setVolumeBucket(2);
            }}
            className="!v2-bg-[#234635]"
            iconColor="#234635"
          />
        </div>
      )}

      <VolumeBucketModels
        modalOpen={isModalOpen}
        setModalOpen={() => setIsModalOpen(false)}
        customerId={customerId}
        volumeBucketLabel={volumeBucketLabel}
        volumeBucket={volumeBucket}
        isTableView={isTableView}
        selectedPeriodid={undefined}
      />
    </div>
  );
};

export default VolumnsCardsContainer;
